import { Component, Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import About from "../component/section/about";
import Achievement from "../component/section/achievement";
import Banner from "../component/section/banner";
import Blog from "../component/section/blog";
import Category from "../component/section/category";
import Course from "../component/section/course";
import Instructor from "../component/section/instructor";
import Sponsor from "../component/section/sponsor";
import Student from "../component/section/student";
import CourseThree from "../component/section/course-3";
import NewsLetter from "../component/section/newsletter";
import Contact from "../component/section/Contact";
import Countries from "../component/section/Countries";
import Feature from "../component/section/feature";
import CategoryTwo from "../component/section/category-2";
import { FaWhatsapp } from 'react-icons/fa';



const Home = () => {
    return (
        <Fragment>
            <Header />
            <section id="home">
                <Banner />

            </section>
            <section id="country">
                <Countries />
            </section>

            <Sponsor />
    


            {/* <Category /> */}
            {/* <Course /> */}
            <section id="courses">
                <CourseThree />

            </section>

          
            <section id="student">
            {/* <NewsLetter /> */}

            {/* <About /> */}




            </section>
            <CategoryTwo/>

            {/* <section id="services">

                <Feature />
                </section> */}
            {/* <section id="partners">
            <Instructor />
            </section> */}

            <section id="blog"></section>

            {/* <Blog /> */}
            {/* <Achievement /> */}
            <Student />

            <section id="contact">
            <Contact />

            </section>

            <Footer />
            <a
            href="https://wa.me/+923095205279"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed left-4 bottom-10 bg-green-500 text-white p-3 rounded-full shadow-lg flex items-center gap-2 hover:bg-green-600 transition"
        >
            <FaWhatsapp size={24} />
        </a>
        </Fragment>
    );
}

export default Home;